<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vQSbYTePNytjzkfb0ZfKcf7LlbCm-Y-jxLbkLyGLfneb6N7aIchxIRzrlT12zhCCaodWegr-B1lp3dG/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>